import { z } from "zod";

// 첨부파일 스키마
const articleAttachmentSchema = z.object({
  attachmentId: z.number(),
  fileName: z.string().nullable(),
  fileSize: z.string().nullable(),
  articleId: z.number(),
});

// 카테고리 스키마
const categorySchema = z.object({
  categoryId: z.number(),
  categoryName: z.string(),
});

// 답글 순서 스키마
const replyArticleSchema = z.object({
  articleId: z.number(),
  content: z.string().nullable(),
  postDate: z.string().nullable(),
});

// 상세 스키마
export const getArticleSchema = z.object({
  category: categorySchema,
  articleId: z.number(),
  title: z.string(),
  content: z.string().optional().default(""), // optional로 변경하고 기본값 설정
  postDate: z.string().optional().default(""), // optional로 변경하고 기본값 설정
  iCafeId: z.string(),
  companyName: z.string(),
  userName: z.string(),
  replyArticle: replyArticleSchema.nullable().optional().default(null), // optional로 변경
  attachments: z.array(articleAttachmentSchema).nullable().optional().default([]), // optional로 변경
});

const articleIdSchema = z.number();

const paginationSchema = z.object({
  page: z.number(),
  size: z.number(),
});

// 페이지네이션 스키마
const paginationsSchema = paginationSchema.merge(
  z.object({
    total: z.number(),
    endPage: z.number(),
  }),
);

// 전체 리스트 응답 스키마
export const getArticlesSchema = z.object({
  pagination: paginationsSchema,
  data: z.array(
    z.object({
      category: categorySchema,
      articleId: articleIdSchema,
      title: z.string(),
      postDate: z.string(),
      reply: z.boolean(),
    }),
  ),
});

// 타입 추론
export type GetArticlesType = z.infer<typeof getArticlesSchema>;
export type ArticleIdType = z.infer<typeof articleIdSchema>;
export type GetArticleType = z.infer<typeof getArticleSchema>;
export type PaginationType = z.infer<typeof paginationSchema>;
